import {
  articleType,
  imageGalleryType,
  imageObjectType,
  newsArticleType,
  tvSeriesType,
  videoObjectType,
  webPageType,
  webSiteType
} from './types';
import { getVideoSchemaDataFromVideoArticle } from './types/videoObjectType';

const addSchema = type => ({
  '@context': 'https://schema.org',
  '@graph': [type]
});

const getType = content => {
  switch (content.bundle) {
    case 'article': {
      if (content.mediaType === 'shortform') {
        return videoObjectType(getVideoSchemaDataFromVideoArticle(content));
      }
      if (content.isEverGreen) {
        return articleType(content);
      }
      return newsArticleType(content);
    }
    case 'homepage': {
      return webSiteType();
    }
    case 'author':
    case 'photographer': {
      return articleType(content);
    }
    case 'error_404':
    case 'error_403':
    case 'hub_page':
    case 'page':
    case 'search':
    case 'subscribe_page':
    case 'taxonomy':
    case 'television_schedule':
    case 'consent_management':
    case 'newsletter': {
      return webPageType(content);
    }
    case 'photo_gallery':
    case 'vertical_slideshow_gallery':
    case 'pod_index': {
      return imageGalleryType(content);
    }
    case 'show': {
      return tvSeriesType(content);
    }
    default: {
      throw new Error(`Unknown content bundle "${content.bundle}".`);
    }
  }
};

export const schemaService = {
  getSchema: content => addSchema(getType(content)),

  getStandaloneImageSchema: imageEntity => {
    const type = imageObjectType(imageEntity);
    return type
      ? {
          '@context': 'https://schema.org',
          ...type
        }
      : undefined;
  },
  getStandaloneVideoSchema: schemaData => {
    const type = videoObjectType(schemaData);
    return type
      ? {
          '@context': 'https://schema.org',
          ...type
        }
      : undefined;
  }
};
